export default __webpack_public_path__ + "static/media/AlterarBanner.f6e85f33.svg";